export default function() {
  //...

  function accordion_toggle() {

    const acc = document.getElementsByClassName("accordion");
    let i;
    
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        this.classList.toggle("active");


        /* Toggle between hiding and showing the active panel */
        const panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }
  }

  accordion_toggle();
  function offices_toggle() {

    const acc = document.getElementsByClassName("block_offices_map__points__accordion-item__accordion");
    const panelItem = document.getElementsByClassName("block_offices_map__points__accordion-item__panel");

    let i;
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        /* Toggle between hiding and showing the active panel */
        const panel = this.nextElementSibling; 
        if(this.classList.contains('active')) {
          panel.style.display = "none";
          this.classList.toggle("active");
        }
        else {
          for (let i = 0; i < panelItem.length; i++) {
            acc[i].classList.remove("active");
            panelItem[i].style.display = "none";
          }
          this.classList.toggle("active");
          if (panel.style.display === "block") {
            panel.style.display = "none";
          } else {
            panel.style.display = "block";
          }
        }
      });
    }
  }

  offices_toggle();

  function employees_toggle() {

    const acc = document.getElementsByClassName("block_employees__row__box__accordion-item-header");
    const colapse = document.getElementsByClassName("block_employees__row__box__accordion-item-collapse");
    let i;
    
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        //this.classList.toggle("active");

        /* Toggle between hiding and showing the active panel */
        const panel = this.nextElementSibling;
        /*if (panel.style.display === "flex") {
          panel.style.display = "none";
        } else {
          panel.style.display = "flex";
        }*/

        if(this.classList.contains('active')) {
          panel.style.display = "none";
          this.classList.toggle("active");
        }
        else {
          for (let i = 0; i < colapse.length; i++) {
            acc[i].classList.remove("active");
            colapse[i].style.display = "none";
          }
          this.classList.toggle("active");
          if (panel.style.display === "flex") {
            panel.style.display = "none";
          } else {
            panel.style.display = "flex";
          }
        }

      });
    }
  }

  employees_toggle();

  /*function menu_top() {

    const link1 = document.getElementById('nav-left').getElementsByClassName("link-1");
    const link2 = document.getElementById('nav-left').getElementsByClassName("link-2");
    const link3 = document.getElementById('nav-left').getElementsByClassName("link-3");
    const link4 = document.getElementById('nav-left').getElementsByClassName("link-4");


    const html1 = '<span id="link-show-1">' + link1[0].innerText + '</span>';
    const html2 = '<span id="link-show-2">' + link2[0].innerText + '</span>';
    const html3 = '<span id="link-show-3">' + link3[0].innerText + '</span>';
    const html4 = '<span id="link-show-4">' + link4[0].innerText + '</span>';

    link1[0].innerHTML = html1;
    link2[0].innerHTML = html2;
    link3[0].innerHTML = html3;
    link4[0].innerHTML = html4;

  } 
  menu_top();*/
}